import { useGetListingAlias } from './routes';
import type { CappsPropertyDetailsWebApiHandler_details_Options } from '@zg-rentals/ts-capps-client-react-query';
import { useCappsPropertyDetailsWebApiHandler_details } from '@zg-rentals/ts-capps-client-react-query';

/**
 * Gets property details using the listing alias from the URL
 */
export function useGetPropertyDetails(options?: Partial<CappsPropertyDetailsWebApiHandler_details_Options>) {
  const listingAlias = useGetListingAlias();
  return useCappsPropertyDetailsWebApiHandler_details(
    {
      listingAlias,
    },
    {
      ...options,
      enabled: !!listingAlias,
    },
  );
}
